import { render, staticRenderFns } from "./SolicitudesNacionalesIndex.vue?vue&type=template&id=a4697f80"
import script from "./SolicitudesNacionalesIndex.vue?vue&type=script&lang=js"
export * from "./SolicitudesNacionalesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports